// libraries
import { MouseEvent } from 'react'
import clsx from 'clsx'

// svg
import { Speaker, SpeakerOff } from '/react4xp/components/Icons/Ux'

// css
import './index.scss'

// types
export interface AudioToggleProps {
	isMuted: boolean
	isPaused: boolean
	onClick: (e: MouseEvent<HTMLButtonElement>) => void
	className?: string
}

export default function AudioToggle({
	isMuted,
	isPaused,
	onClick,
	className
}: AudioToggleProps) {
	return (
		<button
			type='button'
			className={clsx('audio-toggle', className)}
			onClick={onClick}
			aria-label={isMuted || isPaused ? 'Unmute audio' : 'Mute audio'}
		>
			{(isMuted || isPaused) ? (
				<SpeakerOff className='off' />
			) : (
				<Speaker className='on' />
			)}
		</button>
	)
}

